import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx';           // ваш компонент шапки
import klassikaImg from '../images/Классика_картинка.jpg'; // пример картинки
import '../style/CakeDetail.css';

const CakeDetail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div className="detail-container">
        <div className="detail-text">
          <h2>Наполеон Классический</h2>
          <p>Воздушный торт из множества листов тонкого и хрустящего теста, прослоенных нежным кремом.</p>
          <p><strong>Вес:</strong> 1,2&nbsp;кг</p>
          <p><strong>Цена:</strong> 2300&nbsp;₽</p>
          <button onClick={() => navigate(-1)} className="back-button">
            ← Назад
          </button>
        </div>

        <div className="detail-image">
          <img src={klassikaImg} alt="Наполеон Классический" />
        </div>
      </div>
    </>
  );
};

export default CakeDetail;
